<template>
  <ItemDialog ref="dialogRef" imageType="alert">
    <template v-slot:content-area>
      <h2>エラーが発生しました</h2>
      <p style="text-align: center">お手数ですが、もう一度お試しください</p>
    </template>
    <template v-slot:button-area>
      <ItemButton
        label="閉じる"
        actionType="btn-primary"
        @clicked="closeDialog()"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";

import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "DialogReservationFailure",
  setup() {
    const dialogRef = ref(null);

    const openDialog = () => {
      dialogRef.value.open();
    };

    const closeDialog = () => {
      dialogRef.value.close();
      nativeHandlerService.returnNativeDbsWithClose();
    };

    return {
      dialogRef,
      openDialog,
      closeDialog,
    };
  },
};
</script>
